import React from 'react';

import { Asesor } from '../tipos';

import { Button, Modal, Select } from 'semantic-ui-react';

class ModalAtencion extends React.Component<
    {
        nombrePersona: string;
        asesores: ReadonlyArray<Asesor>;
        idAsesorPredeterminado: string;
        alConfirmar(datos: { idAsesor: string }): void;
        alCancelar(): void;
    },
    { idAsesorElegido: string }
> {
    public state = {
        idAsesorElegido: this.props.idAsesorPredeterminado,
    };

    public render() {
        const { asesores, nombrePersona, alConfirmar, alCancelar } = this.props;
        return (
            <Modal
                open
                dimmer='blurring'
                size='tiny'
                onClose={alCancelar}
                closeOnDimmerClick
                closeOnEscape
            >
                <Modal.Header>Registrar atención</Modal.Header>
                <Modal.Content>
                    <p>
                        <strong>{nombrePersona}</strong> se registrará como atendida por el
                        siguiente asesor
                    </p>
                    <Select
                        fluid
                        options={asesores.map(a => ({
                            key: a.id,
                            value: a.id,
                            text: a.nombre,
                        }))}
                        value={this.state.idAsesorElegido}
                        onChange={(_, { value }) =>
                            this.setState({ idAsesorElegido: value as string })
                        }
                    />

                    <p>Puede cambiar al asesor pero esto alterará y reasignará todos los turnos.</p>
                </Modal.Content>
                <Modal.Actions>
                    <Button content='Cancelar' onClick={alCancelar} />
                    <Button
                        primary
                        content='Registrar'
                        icon='check'
                        labelPosition='right'
                        onClick={() => {
                            alConfirmar({ idAsesor: this.state.idAsesorElegido });
                            alCancelar();
                        }}
                    />
                </Modal.Actions>
            </Modal>
        );
    }
}

export default ModalAtencion;



// WEBPACK FOOTER //
// ./src/modulos/Recepcion/TurnosYAtenciones/componentes/ModalAtencion.tsx